import React from 'react';
import * as Entities from "../entities";
import { mapKeys } from 'lodash';
import { createInheritedProvider } from '@shapeable/utils';
export var defaultEntityTypeIconsDefinition = Entities;
export var EntityTypeIconsContext = React.createContext(defaultEntityTypeIconsDefinition);
export var EntityTypeIconsProvider = createInheritedProvider(EntityTypeIconsContext);
export var useEntityTypeIcons = function () {
  var context = React.useContext(EntityTypeIconsContext) || {};
  return mapKeys(context, function (value, key) {
    return key.replace('Icon', '');
  });
};
export var useEntityTypeIconGlyphs = function () {
  var context = React.useContext(EntityTypeIconsContext) || {};
  return mapKeys(context, function (value, key) {
    return key.replace('IconGlyph', '');
  });
};
export var useEntityTypeIcon = function (entityTypeName, noFallback) {
  var components = useEntityTypeIcons();
  return components[entityTypeName] || (noFallback ? null : components['Entity']);
};
export var useEntityTypeIconGlyph = function (entityTypeName, noFallback) {
  var components = useEntityTypeIconGlyphs();
  return components[entityTypeName] || (noFallback ? null : components['Entity']);
};